import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import DebouncedSearchInput, { DebouncedSearchInputRefType } from '@components/atomic/molecules/DebouncedSearchInput/DebouncedSearchInput';
// import { useLocation } from 'react-router-dom';
// import useFilterRedirect from './useFilterRedirect';
import { wrapQueryParams } from './queryParamsUtils';

type CustomSearchRefType = {
	reset: () => void;
};

interface CustomSearchProps {
	activeFilters: { [key: string]: string[] };
	setActiveFilters: React.Dispatch<React.SetStateAction<{ [key: string]: string[] }>>;
	setQueryParams: React.Dispatch<React.SetStateAction<string>>;
	isLoading: boolean;
}

const CustomSearch = forwardRef<CustomSearchRefType, CustomSearchProps>(
	({ activeFilters, setActiveFilters, setQueryParams, isLoading }, ref) => {
		const inputRef = useRef<DebouncedSearchInputRefType>(null);
		// const handleFilterRedirect = useFilterRedirect();
		// const location = useLocation();
		// const isCompleteList = location.search.includes('complete-list=true');

		const setNewQueryParams = (newParams: { name: string; value: string[] }[]) => {
			const queryParamsToSet: Record<string, string[]> = {};
			newParams.forEach(({ name, value }) => {
				if (value.length > 0) queryParamsToSet[name] = value;
			});
			setQueryParams(wrapQueryParams(queryParamsToSet));
		};

		useImperativeHandle(ref, () => ({
			reset: () => {
				inputRef.current?.reset();
				// setActiveFilters({});
				// setQueryParams('');
			},
		}));

		const isFirstRender = useRef(true);

		return (
			<DebouncedSearchInput
				ref={inputRef}
				isLoading={isLoading}
				onSearchTermChange={(term) => {
					if (isFirstRender.current) {
						// Evita la chiamata iniziale
						isFirstRender.current = false;
						return;
					}
					// if (!term) return;
					setActiveFilters((prev) => {
						const newFilters = { ...prev, term: term ? [term] : [] };
						setNewQueryParams(Object.entries(newFilters).map(([name, value]) => ({ name, value })));
						// handleFilterRedirect(newFilters, isCompleteList);
						return newFilters;
					});
				}}
			/>
		);
	},
);

export default CustomSearch;
